import { OverviewMetricsReportDto } from "./overview-metrics-report-dto";

export class InstagramMetricsReportDto extends OverviewMetricsReportDto {

  public Posts: Array<any>[];
  public TotalLikes: number;
  public TotalReach: number;
  public TotalVideoViews: number;
  public TotalComments: number;
  public TotalSaved: number;

  constructor(init: {
    Posts: Array<any>[],
    TotalLikes: number,
    TotalReach: number,
    TotalVideoViews: number,
    TotalComments: number,
    TotalSaved: number,

    TotalPosts: number;
    TotalFollowers: number;
    EngagementRate: number;
    TotalImpressions: number;
  }) {
    super(init);
    this.Posts = init.Posts;
    this.TotalLikes = init.TotalLikes;
    this.TotalReach = init.TotalReach;
    this.TotalVideoViews = init.TotalVideoViews;
    this.TotalComments = init.TotalComments;
    this.TotalSaved = init.TotalSaved;
  }
}  